const maxFiles = 15;

const multipleFileUpload = async () => {
  const multipleFileInputs = document.querySelectorAll(
    '.js-multiple-file-upload'
  );

  multipleFileInputs.forEach(multipleFileInput => {
    multipleFileInput.addEventListener('change', multipleFileInputHandler);
  });
};

const multipleFileInputHandler = event => {
  const input = event.target;

  if (input.files.length === 0) return;

  const filesContainer = document.querySelector(
      input.getAttribute('data-files-container-selector')
    ),
    files = processFiles(input.files);

  if (files.length > 0) filesContainer.classList.add('mt-6');
  filesContainer.innerHTML = '';

  files.forEach(file => {
    const fileName = document.createElement('div');

    fileName.innerHTML = file.name;
    fileName.classList.add('mt-2');

    filesContainer.appendChild(fileName);
  });
};

const processFiles = fileList => {
  let files = [];
  const maxProcessableFiles = maxFiles;

  if (maxProcessableFiles <= 0) return files;

  [...fileList].some(file => {
    if (file.type === 'image/jpeg') {
      files.push(file);

      if (files.length >= maxFiles) return true;
    }
  });

  return files.splice(0, maxFiles);
};

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024,
    dm = decimals < 0 ? 0 : decimals,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export default {
  init: multipleFileUpload,
};
